var map = {
	"./de.json": 489,
	"./en.json": 490,
	"./es.json": 491,
	"./fr.json": 492,
	"./id.json": 493,
	"./it.json": 494,
	"./ja.json": 495,
	"./ko.json": 496,
	"./pt.json": 497,
	"./ru.json": 498,
	"./th.json": 499,
	"./tr.json": 500,
	"./tw.json": 501,
	"./vi.json": 502,
	"./zh.json": 503
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 488;